module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.getProfileHaveClient) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Служба обмена юридически значимыми сообщениями СОЮЗ. ")])]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Общение в службе СОЮЗ позволяет Вам использовать вашу переписку в судах.\n        Для работы в службе СОЮЗ, необходимо определить Юридическое лицо которое Вы представляете.\n        Регистрируйтесь и общайтесь от имени Вашей компании.\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Регистрация")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getProfileHaveClient) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-chat-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRoot),
      expression: "isRoot"
    }],
    attrs: {
      "itemId": _vm.itemId
    }
  }), _vm._v(" "), _c('v-chat', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isRoot),
      expression: "!isRoot"
    }],
    attrs: {
      "itemId": _vm.itemId
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ea0eced","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/ChatPanel.vue
// module id = 1222
// module chunks = 1